<template>
  <div></div>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue"
import PushDataService from "@/services/PushDataService"
import { useAuthenticationStore } from "@/stores/authentication"
import { mapStores } from "pinia"

export default defineComponent({
  name: "ReloadPWA",
  data() {
    return {
      pushInitDone: false,
      pushInitInProgress: false,
      notificationPermissionRequested: false
    }
  },
  computed: {
    ...mapStores(useAuthenticationStore),
    user() {
      return this.authenticationStore.user
    },
  },
  methods: {

    async initSW() {
      if (this.pushInitDone || this.pushInitInProgress) {
        return
      }

      if (navigator.serviceWorker === undefined) {
        //service worker isn't supported
        return
      }

      //don't use it here if you use service worker
      //for other stuff.
      if (window.PushManager === undefined) {
        return
      }

      //register the service worker
      await navigator.serviceWorker.ready
      this.initPush()
    },
    async initPush() {
      if (this.pushInitDone || this.pushInitInProgress) {
        return
      }

      this.pushInitInProgress = true
      
      // Vérifier si l'utilisateur est déjà abonné
      const registration = await navigator.serviceWorker.ready
      const existingSubscription = await registration.pushManager.getSubscription()

      if (existingSubscription) {
        return
      }

      // Ne demander les permissions que si elles n'ont pas encore été demandées
      if (Notification.permission === 'default' && !this.notificationPermissionRequested) {
        this.notificationPermissionRequested = true

        this.pushInitDone = true
        this.pushInitInProgress = false

        await this.subscribeUser()
        return
      }

      this.pushInitDone = true
      this.pushInitInProgress = false
    },
    async subscribeUser() {
      try {
        const registration = await navigator.serviceWorker.ready
        const subscribeOptions = {
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY),
        }

        const pushSubscription = await registration.pushManager.subscribe(subscribeOptions)
        await PushDataService.store(pushSubscription)
      } catch (error) {
        this.pushInitDone = false
      }
    },
    urlBase64ToUint8Array(base64String: string) {
      let padding = "=".repeat((4 - (base64String.length % 4)) % 4)
      let base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/")

      let rawData = window.atob(base64)
      let outputArray = new Uint8Array(rawData.length)

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }
      return outputArray
    },
  },
  watch: {
    user: {
      handler(newUser, oldUser) {
        if (
          newUser &&
          newUser.id &&
          (!oldUser || newUser.id !== oldUser.id) &&
          !this.pushInitDone &&
          !this.pushInitInProgress
        ) {
          this.initSW()
        }
      },
      immediate: true,
    },
  }
})
</script>

